import React, { useEffect } from 'react';

import { ContactOrganizerButton } from '../../components-redesign/ContactOrganizerButton';
import { FollowMessageComponent } from '../../components/FollowMessageComponent';
import { FollowOrganizer } from '../../components/FollowOrganizer';
import { useMyStatsigContext, UseTrustSignalsContext } from '../../context';
import { Organizer } from '../../types';
import { OrganizerTrustSignals } from '../OrganizerTrustSignals';
import './OrganizerDetails.scss';

interface OrganizerDetailsProps {
    organizer?: Organizer;
    totalEvents: number;
    userId: string;
}

export const OrganizerDetails: React.FunctionComponent<
    OrganizerDetailsProps
> = (props) => {
    const { followers, totalEvents, setTotalEvents, setFollowers } =
        UseTrustSignalsContext();
    const { organizerFollowExperiment } = useMyStatsigContext();
    const { organizer, totalEvents: hostedEvents, userId } = props;

    useEffect(() => {
        setTotalEvents(hostedEvents);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [hostedEvents]);

    if (!organizer) {
        return null;
    }

    return (
        <div
            className={
                organizerFollowExperiment
                    ? 'organizer-profile-header__container-experiment'
                    : 'organizer-profile-header__container'
            }
        >
            {organizerFollowExperiment && (
                <div className="organizer-profile-header__container--experiment-container">
                    <OrganizerTrustSignals
                        organizer={organizer}
                        followCount={followers}
                        totalEvents={totalEvents}
                    />
                </div>
            )}
            <div
                className={
                    organizerFollowExperiment
                        ? 'organizer-profile-header__container--button-group-experiment'
                        : 'organizer-profile-header__container--button-group'
                }
            >
                <FollowMessageComponent />
                <FollowOrganizer
                    organizer={organizer}
                    userId={userId}
                    containerClassName={
                        organizerFollowExperiment ? 'target-child-width' : ''
                    }
                    renderFollowCount={(followCount: string) => {
                        setFollowers(Number(followCount));
                        return <></>;
                    }}
                />
                {!organizerFollowExperiment && <ContactOrganizerButton />}
            </div>
            {!organizerFollowExperiment && (
                <OrganizerTrustSignals
                    organizer={organizer}
                    followCount={followers}
                    totalEvents={totalEvents}
                />
            )}
        </div>
    );
};
